<template>
    <vertical-form-table mode="view" v-bind="{ value, items }">
        <template #연락처> ***-****-**** </template>
        <template #날짜> {{ value?.applyDate?.toDate?.() }} </template>
        <template #장비> {{ value?.equipments?.join(", ") }} </template>
        <template #신청상태> {{ APPLICATION_STATUS[value?.status]?.text }} </template>
    </vertical-form-table>
</template>

<script>
import { APPLICATION_STATUS } from '@/assets/variables';

import PageSection from "@/sets/styles/pages/page-section.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import TermsOfAgreementsShort from "@/components/client/terms/terms-of-agreements-short.vue";
// import ImagesInput from "@/components/console/dumb/images-input.vue";
import BtnPrimary2 from "@/components/publish/parents/buttons/btn-primary2.vue";
import BtnSecondary2 from "@/components/publish/parents/buttons/btn-secondary2.vue";
import TextFieldPrimary from "@/components/publish/parents/forms/text-field-primary.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import RadioPrimary from "@/components/publish/parents/forms/radio-primary.vue";
import CheckboxPrimary from "@/components/publish/parents/forms/checkbox-primary.vue";
import CheckboxPrimaryArray from "@/components/publish/parents/forms/checkbox-primary-array.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

const items = [
    {
        key: "name",
        term: "신청자",
        type: "text",
    },
    {
        term: "연락처",
    },
    {
        term: "날짜",
    },
    {
        key: "applyTime",
        term: "시간",
        type: "text",
    },
    {
        term: "장비",
    },
    {
        key: "purpose",
        term: "신청 사유",
        type: "text",
    },
    {
        term: "신청상태",
    },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        PageSection,
        VerticalFormTable,
        TermsOfAgreementsShort,
        // ImagesInput,
        BtnPrimary2,
        BtnSecondary2,
        TextFieldPrimary,
        VDateField,
        RadioPrimary,
        CheckboxPrimary,
        CheckboxPrimaryArray,
        TxtPrimary,
    },
    props: {
        value: { type: Object, default: null },
    },
    setup: () => ({
        items,
        APPLICATION_STATUS
    }),
    data: () => ({}),
    mounted() {},
    methods: {},
    computed: {},
    watch: {},
};
</script>
